import takeC from "./takeC.js";

export default takeC(1);